import React from 'react';

import AgriaLogoFooter from './svg/AgriaLogoFooter';

export const FooterLogo = () => <AgriaLogoFooter />;
